import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../components/Loading";
import PageNotFound from "../PageNotFound";
import { fetchTransactions } from "../../services/transactions";
import PageSelector from '../../components/PageSelector';

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();


    const limit = 10
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem / limit) || 1
    const [data, setData] = useState([])
    const page = parseInt(searchParams.get('page')) || 1
    const filterName = searchParams.get('name')
    const filterType = searchParams.get('type') || '全部'
    useEffect(() => {
        if (!props.token.isLogin) return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData, 1000 * 30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    }, [searchParams, props.token])
    async function fetchData() {
        const filter = { partnerId: id }//{isEarn:{$ne:true}}
        //if(filterType !== '全部') filter['status'] = filterType==='草稿'?'draft':'published'
        //if(filterName) filter['name'] = {"$regex": filterName, "$options":'i'}
        const res = await fetchTransactions(props.token?.token, filter, { limit, skip: limit * (page - 1), sort: { createDate: -1 } })
        if (res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count / limit) || 1
        if (page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage = (p) => () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function selectFilter(item, index) {
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }


    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd]" style={{ overflowY: 'auto' }}>
            <div className='w-full flex flex-row items-center justify-start' style={{ padding: 16, gap: 16 }}>
                <div className='text-[24px] text-[#6E604C] font-bold'>財務報告</div>
            </div>

            <div className='w-full flex flex-row items-start justify-start font-bold' style={{ padding: 16, gap: 8 }}>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">商品</div>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">狀態</div>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">商品數量</div>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">金額</div>
                <div className="flex-1 text-bold text-[14px] text-[#6E604C]">日期</div>
            </div>
            {data?.length === 0 && <div className='w-full flex flex-col items-center justify-center' style={{ padding: 16 }}>
                <div className='text-[16px] text-[#6E604C]'>沒有任何交易記錄</div>
            </div>}

            {data?.map((item, index) => {
                return (
                    <div key={index} className='w-full flex flex-row items-start justify-start' style={{ padding: 16, gap: 8, borderBottom: '1px solid #ccc' }}>
                        <div className='flex-1 text-[14px] text-[#6E604C]' style={{ whiteSpace: 'pre' }}>{item.products?.reduce((acc, p) => acc + (p?.name || '') + '\r\n', '')}</div>
                        <div className='flex-1 text-[14px] text-[#6E604C]'>{item.status}</div>
                        <div className='flex-1 text-[14px] text-[#6E604C]'>{item?.products?.length} 件商品</div>
                        <div className='flex-1 text-[14px] text-[#6E604C]'>金額: {item.tcoin_total} {item?.isCash ? 'HKD' : 'T.Dollar'}</div>
                        <div className='flex-1 text-[14px] text-[#6E604C]'>日期: {new Date(item.createDate).toLocaleDateString()}</div>
                    </div>
                )
            }
            )}

            <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage} />



            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)
